export default {"src":"/_next/static/media/pen_filled.fec86a6a.svg","height":24,"width":24};